<template>
    <div class="circle-container" @mouseover="showTooltip" @mouseleave="hideTooltip" @click="toggleTooltip">
      <div class="circle">?</div>
      <div v-if="isTooltipVisible" class="tooltip">{{ text }}</div>
    </div>
  </template>
  
  <script>
  export default {
    
    props: {
        text: {
            type: String,
            required: true
        }
    },
    data() {
      return {
        isTooltipVisible: false
      };
    },
    methods: {
      toggleTooltip() {
        this.isTooltipVisible = !this.isTooltipVisible;
      },
      showTooltip() {
        this.isTooltipVisible = true;
      },
      hideTooltip() {
        this.isTooltipVisible = false;
      }
    }
  };
  </script>
  
  <style scoped>
  .circle-container {
    position: absolute;
    text-align: right;
    /*position: relative;
    text-align: right;
    align-content: end;*/
    
    right: 30px;
    display: block;
    clear: both;
    float: right;
  }
  
  .circle {
    width: 25px;
    height: 25px;
    background-color: #880000;
    color: #FFFFFF;
    text-align: center;
    font-size: 1.4em;
    font-weight: bold;
    border-radius: 50%;
  }
  
  .tooltip {
    position: absolute;
    left: 100%;
    transform: translateX(-100%);
    top: 100px;
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
    width: 500px;
    text-align: justify;
    text-wrap: wrap;
    z-index: 122000;
    display: block;
    float: left right;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/company/kirc/components/CircleTooltip.vue